import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Source } from '../../models/Source';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'result-list-filter',
  templateUrl: './result-list-filter.component.html',
  styleUrls: ['./result-list-filter.component.css']
})
export class ResultListFilterComponent implements OnInit {
  UserSource: Source;
  IsHidden = false;
  filterForm: FormGroup;
  @Output() onFilter = new EventEmitter<any>();
  constructor(private formBulder: FormBuilder, private authService: AuthService) {
  }

  ngOnInit() {
    this.UserSource = this.authService.getLoginSource();
    this.buildForm();
  }

  buildForm() {
    const first = new Date(2024, 0, 1);
    this.filterForm = this.formBulder.group({
      reference: '',
      hospitalNum: '',
      labNumber: '',
      surname: [''],
      forename: [''],
      email: '',
      dob: '',
      fromDate: [(first).toISOString().substring(0, 10), Validators.required],
      toDate: '',
      testCode: ''
    });
  }

  filterTestResults(filterData) {
    this.onFilter.emit(filterData);
  }
}
